import { useState } from "react";
import { DireccionModel, initValuesDireccionModel } from "../models/ModalDIreccion/direccion.model";

export const useModalDireccion = () => {
  const [direccion, setDireccion] = useState<DireccionModel>(initValuesDireccionModel);
  const handleChange = (e: any, name: string, allinformation: any, setAllInformation: any, nameallinformation: any) => {

    if (name === 'numero_via') {
      e.target.value = e.target.value.replace(/\D/, "");
    }

    if (name === 'numero2_via') {
      e.target.value = e.target.value.replace(/\D/, "");
    }

    if (name === 'numero3_via') {
      e.target.value = e.target.value.replace(/\D/, "");
    }

    if (name === 'letra_via') {
      e.target.value = e.target.value.replace(/[0-9]/ig, "");
    }

    if (name === 'letra2_via') {
      e.target.value = e.target.value.replace(/[0-9]/ig, "");
    }


    let infoupdate: any = { ...direccion };
    if (e.target) {
      infoupdate[name] = e.target.value;
    } else {
      infoupdate[name] = e;
    }

    if (name === "cancelar") {
      infoupdate = {
        tipo_via: null,
        numero_via: "",
        letra_via: "",
        zona_via: null,
        sigo_via: "#",
        numero2_via: "",
        letra2_via: "",
        zona2_via: null,
        numero3_via: "",
        observaciones: "",
        direccion_completa: ""
      };
    } else {
      infoupdate.direccion_completa = `${infoupdate.tipo_via || ""} ${infoupdate.numero_via || ""} ${infoupdate.letra_via || ""} ${infoupdate.zona_via || ""} ${infoupdate.sigo_via || ""} ${infoupdate.numero2_via || ""} ${infoupdate.letra2_via || ""} ${infoupdate.zona2_via || ""} - ${infoupdate.numero3_via || ""} ${infoupdate.observaciones || ""}`;
    }
    setAllInformation({ ...allinformation, [nameallinformation]: infoupdate.direccion_completa })
    setDireccion(infoupdate);
  };
  return { direccion, setDireccion, handleChange };
};
